import { render, staticRenderFns } from "./coffee-category-list-home.vue?vue&type=template&id=001742e4&scoped=true&"
import script from "./coffee-category-list-home.vue?vue&type=script&lang=js&"
export * from "./coffee-category-list-home.vue?vue&type=script&lang=js&"
import style0 from "./coffee-category-list-home.vue?vue&type=style&index=0&id=001742e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001742e4",
  null
  
)

export default component.exports